import { Component, OnInit, ChangeDetectorRef, ElementRef, ViewChild, TemplateRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { EvolutionsFacade } from '../../../../abstraction/evolutions.facade';
import { Evolution } from '../../../../shared/models/evolution';
import { CasesFacade } from '../../../../abstraction/cases.facade';
import { Case } from '../../../../shared/models/case';
import { User } from '../../../../shared/models/user';
import { AuthenticationService } from '../../../../core/authentication.service';
import { FormGroup, FormBuilder } from '@angular/forms';
import { CustomValidators } from '../../../../core/validators/custom-validators';
import mime from 'mime';
import { CategoryOfEvolution } from 'src/app/shared/models/categoryOfEvolution';
import { CategoriesOfEvolutionsQPS } from 'src/app/core/services/categories-of-evolutions.service';
import { CategoriesofEvolutionsFacade } from 'src/app/abstraction/categories-of-evolutions.facade';
import { EvolutionsType } from 'src/app/core/enums/temporalEvolutionType';
import { EvolutionsQPS, PostEvolutionBody } from 'src/app/core/services/evolutions.service';
import { StateTask } from 'src/app/shared/models/stateTask';
import { TasksStates } from 'src/app/core/enums/tasksStates';
import { Task } from 'src/app/shared/models/task';
import { MatDialog } from '@angular/material/dialog';
import Swal from 'sweetalert2';
import { DialogComponent } from 'src/app/shared/components/dialog/dialog.component';
import { AlertService } from 'src/app/core/services/alert.service';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { MessageDialogComponent } from 'src/app/shared/components/message-dialog/message-dialog.component';
import { FileUtilitiesService } from 'src/app/core/services/fileUtilities.service';
import { DialogImageDetailComponent } from 'src/app/shared/components/dialog-image-detail/dialog-image-detail.component';
import { FilePondComponent } from 'ngx-filepond';



@Component({
    selector: 'app-evolutions-side-bar',
    templateUrl: './evolutions-side-bar.component.html',
    styleUrls: ['./evolutions-side-bar.component.scss'],
    animations: [
        trigger('expandCollapse', [
            state('collapsed', style({ height: '0px', opacity: 0, overflow: 'hidden' })),
            state('expanded', style({ height: '*', opacity: 1 })),
            transition('collapsed <=> expanded', animate('300ms ease-in-out'))
        ])
    ]
})
export class EvolutionsSideBarComponent implements OnInit {

    public readonly NOTE = 'note';
    public readonly NOTE_TYPE = 'note_type';
    public readonly NOTE_MEDIA = 'note_media';
    public readonly IS_CRITICAL = 'critical';
    public readonly EVOLUTION_TYPE = 'evolution_type';
    public readonly EVOLUTION_TEXT = 'evolution_text';
    public readonly ADD_EVOLUTION_TEXT = 'add_evolution_text';
    public readonly ADD_EVOLUTION_TYPE = 'add_evolution_type';
    public readonly ADD_EVOLUTION_CRITICAL = 'add_evolution_critical';
    public readonly ADD_EVOLUTION_MEDIA = 'add_evolution_media';

    _user: Subscription;
    _isLoadingGettingEvolutions: Subscription;
    _isLoadingCreatingEvolution: Subscription;
    _isLoadingUpdatingEvolution: Subscription;
    _isLoadingGettingMedia: Subscription;
    _evolutionCategories: Subscription;
    _case: Subscription; case: Case;
    _evolutionsTypeNote: Subscription;

    evolutionForm: FormGroup;
    previousFilter;
    // isLoadingLocalData: boolean = false;
    addEvolutionForm: FormGroup;
    _dialogRef;
    swalWithCustomizeButtons: any;
    evolutionCategories: CategoryOfEvolution[];
    isOpening = false;
    noteTypeError: boolean = false;
    categorySelected: string = null;
    typeSelected: number = null;
    private globalClickUnlistener: () => void;
    updatingEvolution: boolean;
    evolutionToUpdate: Evolution;
    onEvolution: Evolution;
    financierVisibility: boolean;
    providersVisibility: boolean;
    private _photoEvolutionB64: any;
    referedNoteId: number = 0;
    loadingConfirmEndTask;
    EVOLUTIONS_TYPE = EvolutionsType;
    qps: EvolutionsQPS;
    listEvolutionTypes: CategoryOfEvolution[];
    private defaultTextCharged: string;
    private changeTextDescription: boolean;
    loadingAddFile: boolean = false;
    evolutionsWithReference: Evolution[] = [];
    historyOfEvolution: { [key: number]: Evolution[] };
    private allEvolutions: { [key: number]: Evolution[] };
    user: User;
    inputNote: string;
    selectedFileName: string;
    selectedFileExtension: string;
    critical = EvolutionsType.CRITICAL;
    loadingConfirm = false;
    noteFocus = false;
    isLoadingGettingEvolutions: boolean;
    isLoadingCreatingEvolution: boolean;
    isLoadingUpdatingEvolution: boolean;
    isloadingGettingMedia: boolean;
    confirmBtn: boolean = false;
    private _dataEvolutions: { [key: number]: Evolution[] };
    pondOptions = {
        class: 'my-filepond',
        multiple: false,
        labelIdle: 'Arrastre el archivo o haga click aquí',
        labelFileTypeNotAllowed: 'Tipo de archivo inválido',
        fileValidateTypeLabelExpectedTypes: 'Formatos aceptados: jpg, jpeg, png, pdf',
        acceptedFileTypes: ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'],
        allowImagePreview: true,
        imagePreviewMaxHeight: 150,
        maxFileSize: '10MB',
    };

    @ViewChild('myScroll') private myScrollContainer: ElementRef;
    @ViewChild('currentVersion') private currentVersion: ElementRef;
    @ViewChild('historyScroll') private historyScroll: ElementRef;
    @ViewChild('notesTemplate', { static: true, read: true }) public notesTemplate: ElementRef
    @ViewChild('addEvolutionForCase', { static: true }) addEvolutionForCase: TemplateRef<any>;
    @ViewChild('fileInput') fileInput: ElementRef<HTMLInputElement>;


    get photoEvolutionB64() {
        return this._photoEvolutionB64
    }
    set photoEvolutionB64(value) {
        this._photoEvolutionB64 = value;
        this.addEvolutionForm.get(this.ADD_EVOLUTION_MEDIA).patchValue(value)
    }

    get dataEvolutions() {
        return this._dataEvolutions;
    }
    set dataEvolutions(value) {
        this._dataEvolutions = value;
        // setTimeout(() => {
        this.scrollToBottom();
        //     this.isLoadingLocalData = false;
        // }, 5000);
    }

    get evolutionType() {
        return this.evolutionForm.get(this.EVOLUTION_TYPE).value;
    }

    set evolutionType(value) {
        this.previousFilter = value;
        this.evolutionForm.get(this.EVOLUTION_TYPE).setValue(value);
        this.evolutionForm.get(this.NOTE_TYPE).setValue(value);
    }

    get evolutionText() {
        return this.evolutionForm.get(this.EVOLUTION_TEXT).value;
    }

    get addEvolutionText() {
        return this.addEvolutionForm.get(this.ADD_EVOLUTION_TEXT);
    }

    get addEvolutionType() {
        return this.addEvolutionForm.get(this.ADD_EVOLUTION_TYPE);
    }

    set addEvolutionText(value) {
        this.addEvolutionForm.get(this.ADD_EVOLUTION_TEXT).setValue(value);
    }

    set addEvolutionType(value) {
        this.addEvolutionForm.get(this.EVOLUTION_TYPE).setValue(value);
    }

    get patchIsCritical() {
        return this.addEvolutionForm.get(this.ADD_EVOLUTION_CRITICAL);
    }

    set patchIsCritical(value) {
        this.addEvolutionForm.get(this.ADD_EVOLUTION_CRITICAL).setValue(value);
    }

    get isCritical() {
        return this.evolutionForm.get(this.IS_CRITICAL).value;
    }

    get note() {
        return this.evolutionForm.get(this.NOTE).value;
    }

    get noteType() {
        return this.evolutionForm.get(this.NOTE_TYPE).value
    }

    set noteType(value) {
        this.evolutionForm.get(this.NOTE_TYPE).setValue(value);
    }

    get note_media() {
        return this.evolutionForm.get(this.NOTE_MEDIA)
    }

    set note_media(value) {
        this.evolutionForm.get(this.NOTE_MEDIA).setValue(value);
    }

    evolutionIdGettingMedia: number;

    constructor(
        private formBuilder: FormBuilder,
        public fileUtilitiesService: FileUtilitiesService,
        private evolutionsFacade: EvolutionsFacade,
        private casesFacade: CasesFacade,
        private authenticationService: AuthenticationService,
        private cd: ChangeDetectorRef,
        private categoryOfEvolutionFacade: CategoriesofEvolutionsFacade,
        public dialog: MatDialog,
        private alertService: AlertService,
        private categoriesOfEvolutionFacade: CategoriesofEvolutionsFacade,
    ) { }


    ngOnInit(): void {
        this.swalWithCustomizeButtons = Swal.mixin({
            customClass: {
                confirmButton: 'btnSwalConfirm',
                cancelButton: 'btnSwalCancel',
            },
            buttonsStyling: true,
        });

        this._isLoadingGettingMedia = this.evolutionsFacade.isLoadingGettingMedia$().subscribe(loadingMedia => {
            this.isloadingGettingMedia = loadingMedia;
        })

        this.categoriesOfEvolutionFacade.getCategoriesOfEvolutions$().subscribe(
            evolutionCategories => { this.listEvolutionTypes = evolutionCategories?.filter(evoCat => evoCat.category?.includes('NOTA_')) }

        );

        this._isLoadingGettingEvolutions = this.evolutionsFacade.isLoadingGetEvolutions$().subscribe(loading => {
            !loading ? this.scrollToBottom() : null;
            this.isLoadingGettingEvolutions = loading;
        });

        this._isLoadingCreatingEvolution = this.evolutionsFacade.isLoadingCreatingEvolution$().subscribe(loading => {
            !loading ? this.scrollToBottom() : null;
            this.isLoadingCreatingEvolution = loading;
        });

        this._isLoadingUpdatingEvolution = this.evolutionsFacade.isLoadingUpdatingEvolution$().subscribe(loading => {
            !loading ? this.scrollToBottom() : null;
            this.isLoadingUpdatingEvolution = loading;
        });

        // User
        this._user = this.authenticationService.getUser$().subscribe(u => this.user = u)

        // Get case
        this._case = this.casesFacade.getCase$().subscribe(res => {
            this.case = res;
            if (!!this.case) {
                // Evolutions from state
                this.getNotes();
            }
        });
        this.scrollToBottom();

        const qps: CategoriesOfEvolutionsQPS = {
            active: 1
        }
        this._evolutionCategories = this.categoryOfEvolutionFacade.loadCategoriesOfEvolutions(qps).subscribe(
            categories => {
                const notesCategories = categories?.filter(i => i.category?.includes('NOTA_')) || [];
                this.evolutionCategories = this.sortEvolutionsCategories(notesCategories);
            }
        );

        this.evolutionForm = this.createEvolutionForm();
        this.addEvolutionForm = this.createAddEvolutionForm();

        // Observando cambios en el control específico
        this.addEvolutionForm.get(this.ADD_EVOLUTION_TEXT)?.valueChanges.subscribe((newValue) => {
            if (newValue !== this.evolutionToUpdate.text) {
                this.confirmBtn = true;
            }
        });
        this.addEvolutionForm.get(this.ADD_EVOLUTION_CRITICAL)?.valueChanges.subscribe((newValue) => {
            this.confirmBtn = true;
        });
        this.addEvolutionForm.get(this.ADD_EVOLUTION_MEDIA)?.valueChanges.subscribe((newValue) => {
            this.confirmBtn = true;
        });

    }

    // Alert ok
    successMsg = (message) => {
        this.swalWithCustomizeButtons.fire({
            text: message,
            icon: 'success',
            showConfirmButton: false,
            timer: 1500
        }).then(() => {
            return;
        });
    };

    // Alert error
    errorMsg = (message) => {
        this.swalWithCustomizeButtons.fire({
            text: message,
            icon: 'success',
            showConfirmButton: false,
            timer: 1500
        }).then(() => {
            return;
        });
    };

    // Get NOTES
    getNotes() {
        // this.isLoadingLocalData = true;
        this._evolutionsTypeNote = this.evolutionsFacade.getEvolutionsTypeNote$()
            .subscribe((evo: { [key: number]: Evolution[] }) => {
                this.allEvolutions = evo;
                if (!!this.categorySelected) {
                    let array: Evolution[] = [];
                    Object.values(evo).forEach(evolutionsArray => {
                        if (this.categorySelected === 'Sin filtrar' ) {
                            array = evolutionsArray
                        } else {
                            evolutionsArray.forEach(i => {
                                if (i.category?.category === this.categorySelected) {
                                    array.push(i);
                                }
                            });
                        }
                    });

                }
                this.dataEvolutions = evo;
            })
    }

    //Filter notes
    onFilterNotes(value: string) {
        const data = JSON.parse(JSON.stringify(this.allEvolutions));
        for (let key in data) {
            if (data.hasOwnProperty(key)) {
                // Filtrar el array asociado a la clave
                data[key] = data[key].filter(item => item.category.category === value);
            }
        }
        // Asignar el resultado filtrado a dataEvolutions
        this.dataEvolutions = data;
    }

    // app-select-input fx()
    calculateCategoryOfEvolutionId(element: CategoryOfEvolution) {
        return element ? element.id : null;
    }

    // app-select-input fx()
    calculateCategoryOfEvolutionName(element: CategoryOfEvolution) {
        return element ? element.description : null;
    }

    // Sort Categories A-Z
    sortEvolutionsCategories(object) {
        return object.sort((a, b) => {
            return a.description.localeCompare(b.description);
        });
    }

    // Get category by id to Filter Notes
    onSelectCategory(id: number) {
        this.previousFilter = id;
        // Detecta si es "Sin filtrar"
        if (id == null) {
            this.categorySelected = null;
            this.evolutionForm.get(this.NOTE_TYPE).setValue(null);
            this.dataEvolutions = this.allEvolutions
            return;
        }

        // // Detecta si es "Sin filtrar"
        // if (id == 0) {
        //     this.categorySelected = null;
        //     this.evolutionForm.get(this.NOTE_TYPE).setValue(null);
        //     this.dataEvolutions = this.allEvolutions
        //     return;
        // }

        // En caso contrario, filtrar por la categoría real
        const categorySelected: CategoryOfEvolution = this.evolutionCategories.find(category => category.id == id);

        if (categorySelected) {
          this.categorySelected = categorySelected.category;
          this.evolutionForm.get(this.NOTE_TYPE).setValue(id);
          this.onFilterNotes(categorySelected.category);
        }
      }

    // FORM : evolutionForm
    createEvolutionForm(): FormGroup {
        return this.formBuilder.group({
            [this.EVOLUTION_TEXT]: [''],
            [this.EVOLUTION_TYPE]: [null],
            [this.NOTE]: ['', [CustomValidators.required('Ingrese un texto')]],
            [this.NOTE_TYPE]: [null, [CustomValidators.required('Seleccione el tipo de nota')]],
            [this.IS_CRITICAL]: [''],
            [this.NOTE_MEDIA]: ['']
        });
    }

    // onPress ' X ' to close notes
    close() {
        this.evolutionsFacade.setEvolutionsSideBarShow(false);
    }

    // SUBMIT
    addEvolution(event: Event) {
        event.preventDefault();
        this.evolutionForm.markAllAsTouched();
        if (this.evolutionForm.invalid) {
            return;
        }

        const newEvolution: PostEvolutionBody = {
            date: new Date(),
            caseId: this.case.id,
            financierId: this.case.financierId,
            patientId: this.case.patientId,
            type: !!this.isCritical ? EvolutionsType.CRITICAL : EvolutionsType.NORMAL,
            categoryId: this.noteType,
            text: this.note,
            mediaUrls: this.evolutionForm.get(this.NOTE_MEDIA).value !== '' ? [this.evolutionForm.get(this.NOTE_MEDIA).value] : [],
        }

        if (!!this.isCritical) {
            newEvolution.caseOperatorId = this.case.operatorId;
        }
        this.noteFocus = false;
        this.evolutionsFacade.postEvolution(newEvolution).subscribe({
            next: () => {
                this.evolutionForm.reset();
                this.evolutionForm.get(this.EVOLUTION_TYPE).setValue(this.previousFilter);
                this.getNotes(),
                    this.evolutionForm.get(this.NOTE_MEDIA).patchValue('')

            },
            error: (err) => {
                console.error(err)
            }
        });
    }

    // Scroll to the latest note
    scrollToBottom(): void {
        try {
            setTimeout(() => {
                this.myScrollContainer.nativeElement.scrollTop = this.myScrollContainer.nativeElement.scrollHeight;
            }, 200);
        } catch (err) {
            console.log(err);
        }
    }

    // Scroll to Note current version (scroll to center)
    scrollToCurrentVersion(): void {
        setTimeout(() => {
            if (!this.myScrollContainer || !this.currentVersion) {
                return;
            }
            const container = this.myScrollContainer.nativeElement;
            const target = this.currentVersion.nativeElement;
            const containerRect = container.getBoundingClientRect();
            const targetRect = target.getBoundingClientRect();
            const offset = (targetRect.top - containerRect.top) + container.scrollTop;
            const containerHeight = container.clientHeight;
            const targetHeight = target.offsetHeight;
            let center = offset - (containerHeight / 2) + (targetHeight / 2);
            if (center < 0) {
                center = 0;
            }
            const maxScroll = container.scrollHeight - containerHeight;
            if (center > maxScroll) {
                center = maxScroll;
            }
            container.scrollTo({
                top: center,
                behavior: 'smooth'
            });
        }, 0);
    }

    // Show the latest note into the dialog
    historyScrollToBottom(): void {
        try {
            this.historyScroll.nativeElement.scrollTop = this.historyScroll.nativeElement.scrollHeight;
        } catch (err) {
            console.log(err);
        }
    }

    // Filter evolution by id
    filterById(id) {
        const filtered = Object.keys(this.allEvolutions).reduce((acc, key) => {
            const found = this.allEvolutions[key].some(item => item.id === id || item.referencedEvolutionId === id);
            if (found) {
                acc[key] = this.allEvolutions[key];
            }
            return acc;
        }, {});
        this.historyOfEvolution = filtered;
    }

    // This function is called from the history container (edit flow)
    getFlattenedEvolutions(): Evolution[] {
        return Object.values(this.historyOfEvolution).flat();
    }

    // onPress Edit
    openDialogModifyEvolution(evolution: Evolution) {
        this.evolutionToUpdate = evolution
        this.filterById(evolution.id);
        let stateTask: StateTask = {
            id: TasksStates.FINISHED,
        }
        let task: Task = {
            state: stateTask,
            evolution,
        }
        this.updatingEvolution = true;
        let dialogRef = undefined;
        if (!!this.updatingEvolution && this.evolutionToUpdate) {
            this.financierVisibility = this.evolutionToUpdate.visibleFinancier;
            this.providersVisibility = this.evolutionToUpdate.visibleProvider;
            if (this.evolutionToUpdate.mediaUrls) {
                this.photoEvolutionB64 = this.evolutionToUpdate.mediaUrls[0];
            }
        }

        this.openDialog(

            `Gestionar evolución de tipo ${evolution.category.category}`,
            this.addEvolutionForCase,
            { maxHeight: '95vh', minWidth: '65%' },
            () => {
                this.photoEvolutionB64 = null;
            }
        );
        this.addEvolutionForm.get(this.ADD_EVOLUTION_TEXT).setValue(evolution.text)
        this.historyScrollToBottom();
    }

    // onPress Restore (Facade)
    restoreNote(evolution: Evolution) {
        const data = evolution;
        data.active = true;
        this.evolutionsFacade.patchEvolution(data).subscribe({
            next: (patchedEvolution) => {
                this.successMsg('La nota fué restaurada con éxito');
            },
            error: (err) => {
                this.errorMsg('A ocurrido un error al restaurar la nota');
            }
        });
    };

    // onPress Delete (Facade)
    // deleteNote(evolution: Evolution) {
    //     this.showAlert();
    //     this._dialogRef.componentInstance.ok.subscribe(result => {
    //         if (result) {
    //             const data = evolution;
    //             data.active = false;
    //             this.evolutionsFacade.patchEvolution(data).subscribe({
    //                 next: (patchedEvolution) => {
    //                     this._dialogRef.close();
    //                     this.successMsg('La nota fué eliminada con éxito');
    //                 },
    //                 error: (err) => {
    //                     this.errorMsg('A ocurrido un error al restaurar la nota');
    //                 }
    //             });
    //         }
    //     });
    // }

    deleteNote(evolution:Evolution){
        const swalWithCustomizeButtons = Swal.mixin({
            customClass: {
                confirmButton: 'btnSwalConfirm',
                cancelButton: 'btnSwalCancel'
            },
            buttonsStyling: true
        })
        swalWithCustomizeButtons.fire({
            text: '¿Seguro que desea Eliminar?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'CONFIRMAR',
            cancelButtonText: 'CANCELAR',
            reverseButtons: true
        }).then((result) => {
            if (result.isConfirmed) {
                const data = evolution;
                data.active = false;
                this.evolutionsFacade.patchEvolution(data).subscribe({
                    next: (data) => {
                        this._dialogRef.close();
                        this.successMsg('La nota fué eliminada con éxito');
                    },
                    error: (err) => {
                        this.errorMsg('A ocurrido un error al eliminar la nota');
                    }
                });
            }
    } )
}

    // show delete dialog
    showAlert() {
        this._dialogRef = this.dialog.open(MessageDialogComponent, {
            disableClose: false,
            maxHeight: '20%',
            maxWidth: '50vh',
            data: {
                message: `Se eliminirá la nota, ¿Desea continuar? Esta acción se puede revertir.`,
                icon: 'WarningCircle',
                disableConfirm: true,
            }
        });
    }

    // on Note Update
    openDialog(title: string, template, style: { minWidth: string, maxHeight: string }, afterClosed?): void {
        this._dialogRef = this.dialog.open(DialogComponent, {
            disableClose: true,
            minWidth: style.minWidth,
            maxHeight: style.maxHeight,
            data: { template, title },
        });
        this._dialogRef.afterClosed().subscribe(() => {afterClosed(),this.addEvolutionForm.reset() ,this.confirmBtn = false});
    }

    // onChange add_evolution_text
    onChangeDescription(event) {
        let categorySelected: CategoryOfEvolution = this.listEvolutionTypes.find(category => console.log(category));
        if (categorySelected && event.target.value != '') {
            this.changeTextDescription = (categorySelected.defaultText != event.target.value);
        } else {
            if (event.target.value == '') {
                this.changeTextDescription = false;
            } else {
                this.changeTextDescription = (!categorySelected);
            }
        }
    }

    // Evolution calculate id
    calculateId(element: CategoryOfEvolution) {
        return element ? element.id : null;
    }

    // Evolution calculate description
    calculateName(element: CategoryOfEvolution) {
        return element ? element.description : null;
    }

    // Init Attached file logger
    pondHandleInit() {
        console.log('Inicio la cargaaa');
    }

    // Add Attached file
    pondHandleAddFile(event: any) {
        if (!event.error) {
            const b64 = event.file.getFileEncodeBase64String();
            const extension = event.file.fileExtension;
            const mimeType = mime.getType(extension);
            this.photoEvolutionB64 = `data:${mimeType};base64,${b64}`;
        } else {
            this.photoEvolutionB64 = null;
        }
        this.loadingAddFile = false;
    }

    // Remove Attached file
    pondHandleRemoveFile(event) {
        this.photoEvolutionB64 = null;
    }

    // Attached file process flag
    pondHandleProcessFile(event) {
        this.loadingAddFile = true;
    }

    // onClick Cancel --> UPDATE
    onCancelClick() {
        this._dialogRef.close();
    }

    // onClick Confirm --> UPDATE
    onConfirmClick() {
        this.loadingConfirm = true;
        let postEvolutionObject: PostEvolutionBody;
        if (!!this.updatingEvolution) {
            postEvolutionObject = {
                caseId: this.case.id,
                financierId: this.case.financierId,
                patientId: this.case.patientId,
                caseOperatorId: this.case.operatorId,
                text: this.addEvolutionForm.get(this.ADD_EVOLUTION_TEXT).value,
                type: this.addEvolutionForm.get(this.ADD_EVOLUTION_CRITICAL).value ? EvolutionsType.CRITICAL : EvolutionsType.NORMAL,
                categoryId: this.evolutionToUpdate.category.id,
                date: new Date(),
                mediaUrls: [this.photoEvolutionB64],
                visibleFinancier: this.financierVisibility,
                visibleProvider: this.providersVisibility,
                referencedEvolution: this.evolutionToUpdate.id
            };
        }
        this.postEvolution(postEvolutionObject);
        this.evolutionForm.reset();
        this.noteFocus = false;
        // this.scrollToBottom();
    }

    // Http post
    postEvolution(evolution) {
        this.evolutionsFacade.postEvolution(evolution, true).subscribe(
            (evolucion) => {
                this.loadingConfirm = false;
                this._dialogRef.close(evolucion);
                this.noteFocus = !this.noteFocus;
                this.getNotes()

            },
            (error) => {
                this.loadingConfirm = false;
                this.alertService.openError(error.message)
            }
        );
    }

    // Create addEvolutionForm
    createAddEvolutionForm(): FormGroup {
        if (this.updatingEvolution) {
            return this.formBuilder.group({
                [this.ADD_EVOLUTION_TEXT]: [(this.evolutionToUpdate.text) ? this.evolutionToUpdate.text : '', [CustomValidators.required('Texto requerido'), CustomValidators.minLength(10, 'La evolución debe tener al menos 10 caracteres')]],
                [this.ADD_EVOLUTION_TYPE]: [(this.evolutionToUpdate.category) ? this.evolutionToUpdate.category.id : '',],
                [this.ADD_EVOLUTION_CRITICAL]: [''],
                [this.ADD_EVOLUTION_MEDIA]: [null],
            });
        } else {
            return this.formBuilder.group({
                [this.ADD_EVOLUTION_TEXT]: ['', [CustomValidators.required('Texto requerido'), CustomValidators.minLength(10, 'La evolución debe tener al menos 10 caracteres')]],
                [this.ADD_EVOLUTION_TYPE]: ['',],
                [this.ADD_EVOLUTION_CRITICAL]: [''],
                [this.ADD_EVOLUTION_MEDIA]: [null],
            });
        }
    }

    // Open edited view
    getHistoryWithId(id) {
        this.referedNoteId = id;
        this.scrollToCurrentVersion()
    }

    // Close edited view
    closeRef() {
        this.referedNoteId = 0;
    }

    // Add Note Collapsed Controller
    closeFocus(event: Event) {
        event.preventDefault();
        this.noteFocus = false;
    }

    // Add Note Expand Controller
    openFocus(event: Event) {
        event.preventDefault();
        this.noteFocus = true;
    }

    // Show images
    openDialogImage(_image, buttons?): void {
        const dialogRef = this.dialog.open(DialogImageDetailComponent, {
            width: '50%',
            data: { image: _image, buttons },
        });
        dialogRef.afterClosed().subscribe((result) => {
        });
    }

    // Show mediaUrls
    downloadMedia(data: Evolution) {
        this.evolutionIdGettingMedia = data.id;
        this.evolutionsFacade.getMediaByEvolutionId(data.id).subscribe(mediaFiles => {
            if (mediaFiles.mediaUrls.length > 0) {
                mediaFiles.mediaUrls.forEach(elem => {
                    if (this.fileUtilitiesService.isPdf(elem)) {
                        this.fileUtilitiesService.downloadFile(elem)
                    } else if (this.fileUtilitiesService.isPhoto(elem)) {
                        this.openDialogImage(elem)
                    }
                    this.evolutionIdGettingMedia = null;
                })
            }
        })
    }

    // Clean on close component
    ngOnDestroy(): void {

        this.dataEvolutions = null;
        this.allEvolutions = null;
        this.categorySelected = null;
        this.evolutionForm.reset();

        this._isLoadingGettingMedia.unsubscribe();

        if (this.globalClickUnlistener) {
            this.globalClickUnlistener();
        }

        this.isOpening = false;
        if (!!this._case) {
            this._case.unsubscribe();
        }

        if (!!this._evolutionsTypeNote) {
            this._evolutionsTypeNote.unsubscribe();
        }

        if (!!this._user) {
            this._user.unsubscribe();
        }
    }

    openFileDialog(event: MouseEvent): void {
        event.stopPropagation();
        event.preventDefault();
        this.fileInput.nativeElement.click();
    }

    // Add Attached file
    onFileSelected(event: any) {
        const file: File = event.target.files && event.target.files[0];
        const maxSizeInBytes = 10 * 1024 * 1024;
        if (file) {
            if (file.size > maxSizeInBytes) {
                this.alertService.openError('El archivo excede el tamaño máximo permitido de 10 MB.');
                return;
            }
            const reader = new FileReader();
            reader.onload = () => {
                const dataUrl: string = reader.result as string;
                // Separamos la parte de base64 (después de la coma)
                const base64String = dataUrl.split(',')[1];
                // Obtenemos la extensión y el MIME type
                const extension = file.name.split('.').pop();
                const mimeType = file.type; // También puedes usar alguna librería como mime si lo requieres
                // Actualizamos el formulario
                this.evolutionForm.get(this.NOTE_MEDIA).patchValue(`data:${mimeType};base64,${base64String}`);
                // Limpiar el valor del input para evitar re-disparar el diálogo
                this.fileInput.nativeElement.value = '';
                // Opcional: quitar el foco del input
                this.fileInput.nativeElement.blur();
            };

            // Leer el archivo como DataURL para obtener el string en base64
            reader.readAsDataURL(file);
            // Obtener el nombre completo del archivo (acortado si es necesario)
            this.selectedFileName = this.shortenFilename(file.name)
        } else {
            // Si no se seleccionó archivo o ocurrió un error
            this.evolutionForm.get(this.NOTE_MEDIA).patchValue('');
            this.fileInput.nativeElement.value = '';
            this.fileInput.nativeElement.blur();
        }

        this.loadingAddFile = false;
    }

    shortenFilename(filename) {
        // Lista de extensiones permitidas
        const validExtensions = [".jpg", ".jpeg", ".png", ".pdf"];
        // Encontrar la extensión del archivo
        let variable1 = "";
        for (let ext of validExtensions) {
            if (filename.endsWith(ext)) {
                variable1 = ext;
                break;
            }
        }
        // Si no tiene una extensión válida, retornar el filename original
        if (!variable1) return filename;
        // Obtener el nombre sin la extensión
        let variable2 = filename.slice(0, -variable1.length);
        // Acortar si es mayor a 15 caracteres
        if (variable2.length > 15) {
            variable2 = variable2.slice(0, 15) + "...";
        }
        // Retornar el nuevo nombre acortado con la extensión
        return variable2 + variable1;
    }


    onPressDeleteFile(event: MouseEvent): void {
        event.stopPropagation();
        event.preventDefault();
        this.showAlertOnDeleteFile();
    }

    // show delete dialog
    showAlertOnDeleteFile() {
        const swalWithCustomizeButtons = Swal.mixin({
            customClass: {
                confirmButton: 'btnSwalConfirm',
                cancelButton: 'btnSwalCancel'
            },
            buttonsStyling: true
        })
        swalWithCustomizeButtons.fire({
            text: '¿Eliminar archivo adjunto?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'CONFIRMAR',
            cancelButtonText: 'CANCELAR',
            reverseButtons: true
        }).then((result) => {
            if (result.isConfirmed) {
                this.evolutionForm.get(this.NOTE_MEDIA).patchValue('')
                this.successMsg('Archivo multimedia eliminado con éxito');
                this._dialogRef?.close();
        }});
    }

    previewMedia() {
        const file = this.evolutionForm.get(this.NOTE_MEDIA).value;
        if (this.fileUtilitiesService.isPdf(file)) {
            this.fileUtilitiesService.downloadFile(file)
        } else if (this.fileUtilitiesService.isPhoto(file)) {
            this.openDialogImage(file, false)
        }
    }

    // onclickEyeProvider(evo: Evolution) {
    //     evo.visibleProvider = !evo.visibleProvider;
    //     this.evolutionsFacade.patchEvolution(evo).toPromise()
    //         .then((_) => {
    //             // Nothing
    //         })
    //         .catch((err) => {
    //             console.log('error', err);
    //         });
    // }


    // onclickEyeFinancier(evo: Evolution) {
    //     evo.visibleFinancier = !evo.visibleFinancier;
    //     this.evolutionsFacade.patchEvolution(evo).toPromise()
    //         .then((_) => {
    //             // Nothing
    //         })
    //         .catch((err) => {
    //             console.log('error', err);
    //         });
    // }

}
